export default __webpack_public_path__ + "media/zurb/img/legacy/icons/notable/pro-solidify-1a28778fbbea3faca458318b193c405b.png";